import React, { useState } from 'react';
import { Lock, Mail, AlertCircle } from 'lucide-react';
interface LoginScreenProps {
  onLogin: (email: string, password: string) => void;
  error?: string;
  isLoading?: boolean;
}
const LoginScreen: React.FC<LoginScreenProps> = ({
  onLogin,
  error,
  isLoading = false
}) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onLogin(email, password);
  };
  return <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8" data-id="element-721">
      <div className="sm:mx-auto sm:w-full sm:max-w-md" data-id="element-722">
        <div className="flex justify-center" data-id="element-723">
          <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center" data-id="element-724">
            <Lock className="w-8 h-8 text-white" data-id="element-725" />
          </div>
        </div>
        <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900" data-id="element-726">
          Professional Growth Platform
        </h2>
        <p className="mt-2 text-center text-sm text-gray-600" data-id="element-727">
          Sign in to access your growth dashboard
        </p>
      </div>
      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md" data-id="element-728">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10" data-id="element-729">
          <form className="space-y-6" onSubmit={handleSubmit} data-id="element-730">
            {error && <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-md flex items-start" data-id="element-731">
                <AlertCircle className="w-5 h-5 mr-2 flex-shrink-0 mt-0.5" data-id="element-732" />
                <span data-id="element-733">{error}</span>
              </div>}
            <div data-id="element-734">
              <label htmlFor="email" className="block text-sm font-medium text-gray-700" data-id="element-735">
                Email address
              </label>
              <div className="mt-1 relative rounded-md shadow-sm" data-id="element-736">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-737">
                  <Mail className="h-5 w-5 text-gray-400" data-id="element-738" />
                </div>
                <input id="email" name="email" type="email" autoComplete="email" required value={email} onChange={e => setEmail(e.target.value)} className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" placeholder="you@example.com" data-id="element-739" />
              </div>
            </div>
            <div data-id="element-740">
              <label htmlFor="password" className="block text-sm font-medium text-gray-700" data-id="element-741">
                Password
              </label>
              <div className="mt-1 relative rounded-md shadow-sm" data-id="element-742">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-743">
                  <Lock className="h-5 w-5 text-gray-400" data-id="element-744" />
                </div>
                <input id="password" name="password" type="password" autoComplete="current-password" required value={password} onChange={e => setPassword(e.target.value)} className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" data-id="element-745" />
              </div>
            </div>
            <div className="flex items-center justify-between" data-id="element-746">
              <div className="flex items-center" data-id="element-747">
                <input id="remember-me" name="remember-me" type="checkbox" className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" data-id="element-748" />
                <label htmlFor="remember-me" className="ml-2 block text-sm text-gray-900" data-id="element-749">
                  Remember me
                </label>
              </div>
              <div className="text-sm" data-id="element-750">
                <a href="#" className="font-medium text-blue-600 hover:text-blue-500" data-id="element-751">
                  Forgot your password?
                </a>
              </div>
            </div>
            <div data-id="element-752">
              <button type="submit" disabled={isLoading} className={`w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 ${isLoading ? 'opacity-70 cursor-not-allowed' : ''}`} data-id="element-753">
                {isLoading ? 'Signing in...' : 'Sign in'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>;
};
export default LoginScreen;